import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Protected Route Component
 * Prevents unauthorized access to protected pages
 */
const ProtectedRoute = ({ isAuthenticated, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
